var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDropdown = function SvgDropdown(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 0H1.875C0.839534 0 0 0.839534 0 1.875V13.125C0 14.1605 0.839534 15 1.875 15H13.125C14.1605 15 15 14.1605 15 13.125V1.875C15 0.839534 14.1605 0 13.125 0ZM14.0625 13.125C14.0625 13.6425 13.643 14.0625 13.125 14.0625H1.875C1.35703 14.0625 0.9375 13.6425 0.9375 13.125V1.875C0.9375 1.3575 1.35703 0.9375 1.875 0.9375H13.125C13.643 0.9375 14.0625 1.35703 14.0625 1.875V13.125ZM11.3738 4.83515L7.49297 8.73L3.61218 4.83515C3.42797 4.64998 3.12936 4.64998 2.94515 4.83515C2.76093 5.02029 2.76093 5.31983 2.94515 5.505L7.13578 9.71061C7.23424 9.80907 7.36407 9.85123 7.49297 9.84468C7.6214 9.85125 7.75174 9.80907 7.85015 9.71061L12.0408 5.505C12.225 5.31985 12.225 5.01985 12.0408 4.83515C11.8561 4.65 11.558 4.65 11.3738 4.83515Z",
    fill: "black"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDropdown, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dropdown.a79710a1.svg";
export { ForwardRef as ReactComponent };